import React from 'react';
import { LoadingIndicator } from '@xolv-mybrightlink/common';
import { useEventContext } from './hooks/useEventContext';
import { EventProvider } from './reducer/EventProvider';
import { useFetchEventCategories } from './hooks/useFetchEventCategories';

const EventInit = (props: { children: React.ReactNode }) => {
  const [state] = useEventContext();
  useFetchEventCategories();
  if (state.initial) {
    return <LoadingIndicator fullHeight />;
  }
  return <>{props.children}</>;
};

export const EventRoute = (props: { children: React.ReactNode }) => {
  return (
    <EventProvider>
      <EventInit>{props.children}</EventInit>
    </EventProvider>
  );
};
